import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { forwardRef, useImperativeHandle, useState } from "react";

const ReportPDFEmailForm = forwardRef((props, ref) => {
  const [values, setValues] = useState({
    from: "",
    to: "",
    subject: "",
    body: "",
  });

  // ✅ Expose getValues to parent via ref
  useImperativeHandle(ref, () => ({
    getValues: () => values,
  }));

  const handleChange = (field) => (e) => {
    setValues((prev) => ({ ...prev, [field]: e.target.value }));
  };

  return (
    <StyledGridRow>
      <StyledGridCol xs={24}>
        <FormItem label="From">
          <TextField value={values.from} onChange={handleChange("from")} />
        </FormItem>
      </StyledGridCol>
      <StyledGridCol xs={24}>
        <FormItem label="To">
          <TextField value={values.to} onChange={handleChange("to")} />
        </FormItem>
      </StyledGridCol>
      <StyledGridCol xs={24}>
        <FormItem label="Subject">
          <TextField value={values.subject} onChange={handleChange("subject")} />
        </FormItem>
      </StyledGridCol>
      <StyledGridCol xs={24}>
        <FormItem label="Body">
          <TextField inputType="textarea" value={values.body} onChange={handleChange("body")} />
        </FormItem>
      </StyledGridCol>
    </StyledGridRow>
  );
});

export default ReportPDFEmailForm;